const checkboxes = [
  {
    name: 'Saturday',
    key: '6',
    value: '6',
  },
  {
    name: 'Sunday',
    key: '7',
    value: '7',
  },
  {
    name: 'Monday',
    key: '1',
    value: '1',
  },
  {
    name: 'Tuesday',
    key: '2',
    value: '2',
  },
  {
      name: 'Wednesday',
      key: '3',
      value: '3',
    },
    {
      name: 'Thursday',
      key: '4',
      value: '4',
    },
    {
      name: 'Friday',
      key: '5',
      value: '5',
    },
];

export default checkboxes;